import * as actions from './actions';
import * as reducers from './reducers';
import sagas from './sagas';
export { default as ConfigurationRoute } from './ConfigurationRoute';

export default {
	actions,
	reducers,
	sagas
};
